// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/transformation_templates_datatable" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsTransformationTemplatesDatatable } from "./constants";
import type {
  AppsTransformationTemplatesDatatableParams,
  AppsTransformationTemplatesDatatableResult,
} from "./types";

export const getDataTableAppsTransformationTemplates = reactQueryTableFetcherAdapter(
  appsTransformationTemplatesDatatable,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      endpoint,
    }: AppsTransformationTemplatesDatatableParams
  ): Promise<AppsTransformationTemplatesDatatableResult> => {
    return fetch(
      "/apps/transformation_templates_datatable",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        endpoint,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
